import axiosInstance from '@/services'
import { useFormStore } from '@/stores/form'
import client_config from '@/assets/json/client_config.json'

export default async function () {
  const formStore = useFormStore()

  try {
    const res = await axiosInstance.post('/api/icaRequest/draft/submitApplication', {
      ...formStore.draft
    })

    const {
      request: { pran, eidaPayment, requireEnrollmentInd, appointments },
      externalReferenceNumber
    } = res

    Object.assign(formStore.draft, { externalReferenceNumber })
    Object.assign(formStore.draft.request, {
      pran,
      eidaPayment,
      requireEnrollmentInd,
      externalReferenceNumber
    })

    if (client_config.showAppointmentsBooking && !requireEnrollmentInd && appointments) {
      Object.assign(formStore.draft.request, {
        appointments: null
      })
    }
  } catch (error) {
    console.error('Error submitting application: user580PreReview', error)
  }
}
